import * as Helpers from '../helpers'
import * as Outline from '@heroicons/react/outline'

export default function Close({onClick, className}) {
    return <button onClick={onClick} className={Helpers.classNames(className, 'videos-close')}>
        <Outline.XIcon/>
    </button>
}
